import { render, staticRenderFns } from "./NeedsAnalysisDetails.vue?vue&type=template&id=3a3de13a&scoped=true&"
import script from "./NeedsAnalysisDetails.vue?vue&type=script&lang=js&"
export * from "./NeedsAnalysisDetails.vue?vue&type=script&lang=js&"
import style0 from "./NeedsAnalysisDetails.vue?vue&type=style&index=0&id=3a3de13a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3de13a",
  null
  
)

export default component.exports